module.exports = __webpack_public_path__ + "lp/img/chat_icon_sp_on@2x.78b401a1.png";